import { Component } from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';

export class EntityRefData extends Component {
  static propTypes = {
    withoutUpdates: PropTypes.bool,
    entityType: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    children: PropTypes.func.isRequired,
    allEntities: PropTypes.object.isRequired,
  };

  static defaultProps = {
    entityType: 'assets',
    withoutUpdates: false,
  };

  shouldComponentUpdate() {
    return !this.props.withoutUpdates;
  }

  getEntryData = id => path([this.props.entityType, id], this.props.allEntities);

  render() {
    const { children, id } = this.props;

    if (!id) {
      return children({});
    }

    if (Array.isArray(id)) {
      return children(id.map(this.getEntryData));
    }
    return children(this.getEntryData(id));
  }
}
